<template>
  <div class="collection-slider-wrapper">
    <div class="slider-header text-center">
      <h2 class="merriweather-light-reg-26">Des séjours pensés</h2>
      <h2 class="merriweather-light-reg-40">Pour chaque envie</h2>
      <p class="merriweather-light-24">Des collections exclusives où chaque séjour est un <span class="merriweather-light-italic-24">privilège</span></p>
    </div>
    <div class="collection-border-bottom">
      <div class="row collection-border"></div>
    </div>
    <div class="slider-container position-relative" data-aos="fade-up" data-aos-duration="900">

      <slither-slider
        ref="slider"
        :options="{
          loop: false,
          autoplay: false,
          numberOfSlides: 4,
          dots: false,
          controls: true,
          gap: 24
        }"
      >
        <template v-for="(collection, index) in collectionsMounted">
          <div class="collection-card">
            <div class="card-hub zoom-img-container cursor-pointer" @click="goToCollection(getCollectionUrl(collection.slug))">
              <img v-if="collection.photo_key" :src="collection.photo_key" class="img-collection zoom-img" :alt="collection.name">
              <img v-else src="https://hortense-vue.s3.eu-west-3.amazonaws.com/static/default.jpg" class="img-collection zoom-img" :alt="collection.name">
              <p class="merriweather-italic-24">{{ collection.name }}</p>
            </div>
            <div class="d-flex flex-column justify-content-center align-items-center text-center pt-3">
              <span class="subtitle-card raleway-bold-p16">{{ collection.title }}</span>
              <a :href="getCollectionUrl(collection.slug)" class="link-hortense raleway-reg-p15" target="_blank">Découvrir la collection</a>
            </div>
          </div>
        </template>
        <template slot="previous">
          <div class="circle-icon previous-slide-button">
            <img src="../../images/arrow-left.svg" alt="Previous" />
          </div>
        </template>
        <template slot="next">
          <div class="circle-icon next-slide-button">
            <img src="../../images/arrow-right.svg" alt="Next" />
          </div>
        </template>
      </slither-slider>
    </div>
  </div>
</template>


<script>
  import AOS from 'aos';
  import CardCollection from 'components/cards/CardCollection.vue';
  export default {
    name: 'CollectionHome',
    components: { CardCollection },
    props: {
      collections: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        value: 4,
      }
    },
    methods: {
      goToCollection(url) {
        window.open(url, '_blank');
      },
      getCollectionUrl(slug) {
        if (slug && slug.startsWith('vacances-')) {
          return '/' + slug;
        }
        return '/collections/' + slug;
      }
    },
    computed: {
      collectionsMounted() {
        const collections = [...this.collections];

        // Extract Séraphine
        const seraphineIndex = collections.findIndex(c => c.name.trim() === 'Séraphine');
        let seraphine = null;

        if (seraphineIndex !== -1) {
          seraphine = collections.splice(seraphineIndex, 1)[0];
        }

        const vacations = [
          {
            name: "Vacances d'été",
            title: "Sous le soleil",
            photo_key: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-ete.webp",
            slug: "vacances-ete"
          },
          {
            name: "Vacances de printemps",
            title: "Réveil de la Nature",
            photo_key: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-printemps.webp",
            slug: "vacances-printemps"
          },
          {
            name: "Vacances de Noël",
            title: "Au coeur des fêtes",
            photo_key: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-noel.webp",
            slug: "vacances-noel"
          },
          {
            name: "Vacances d'hiver",
            title: "Charme hivernal",
            photo_key: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-hiver.webp",
            slug: "vacances-hiver"
          },
          {
            name: "Vacances de la Toussaint",
            title: "Couleurs d'automne",
            photo_key: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-toussaint.webp",
            slug: "vacances-toussaint"
          }
        ];

        return seraphine
          ? [...collections, seraphine, ...vacations]
          : [...collections, ...vacations];
      }
    },
    mounted() {
      AOS.init();
    }
  }
</script>


<style lang="scss" scope='app/assets/stylesheets/components/card-collection'>

.col-weekend{
  padding-left: 40px;
}

.collection-slider-wrapper {
  background: url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/hortense-collections.webp');
  background-position: center 56%;
  max-height: 850px;
  padding-top: 80px;
  color: white;
  width: 100%;

  .collection-border {
    border-bottom: 1px solid white;
  }
  .collection-border-bottom {
    padding-left: 100px;
    padding-right: 100px; 
    padding-bottom: 0 !important;
  }

  .previous-slide-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 180px;
    color: #F7F7F7;
  }

  .next-slide-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 180px;
    color: #F7F7F7;
  }

  .circle-icon {
    width: 44px;
    height: 46px;
    border: 1px solid #F7F7F7;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .slither-slider {
    padding: 40px 250px 40px 250px;
    width: 100% !important;
  }
  .slither-slider-slide{
    position: relative;
    height: auto;
    display: grid;
    grid-template-columns: repeat(4, minmax(0px, 1fr)) !important;
    gap: 30px;
  }

  .slider-container {
    max-width: 100% !important;
  }

  .img-collection {
    width: 100%;
    height: 389px;
    object-fit: cover;
  }

  .card-hub {
    position: relative;
    width: 100%;
    height: 330px;
    cursor: pointer;
  }

  .card-hub img {
    width: 100%;
    height: 330px;
    object-fit: cover;
    border-radius: 15px;
  }

  .card-hub p {
    position: absolute;
    bottom: 0.5rem;
    left: 0;
    right: 0;
    text-align: center;
    color: white;
  }

  .collection-card {
    .link-hortense {
      color: white;
    }
  }

  .zoom-img-container {
    border-radius: 15px;
  }
}
</style>
